import Vue from 'vue'
import Vuex from 'vuex'
//vuex-persist的作用是保证vuex的数据在刷新页面之后也能持久化
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

export default new Vuex.Store({
    plugins: [vuexLocal.plugin],
    state: {
        stepData: 0,
        langPage: {},
        lang: 'fr',
        categories: {},
        categoriesIds: {},
        fast_categoryId: 11,//顶部菜单男 女 孩子的id
        fast_category_name: '',//顶部菜单男 女 孩子的category名字
        token: '',
        menu: '',
        queryRemiseCodes: [],//优惠券数组
        commandes_remises: [],//优惠券数组 新的  包含订单优惠码数据
        order_confirm: {},//用户的下单数据，要到支付页面进行确认
        userInfo: {},//用户个人数据，登录后重置
        isMobile: false,
        partnerDeliverGroupPrice: 3,//合作物流团发价格
        isHalfWidthContainer: false,
        isFirstLoadPage: true,//是否是第一次加载vue页面，是第一次要重新刷新该页面
        cookieSaveType: '',//cookie保存类型 base基础  normal普通  full全部
        client_page_imgs: {
            home: {},
            homeLogin: {},
        },//前端页面的图片 {home:{top_bg1:{file_url:''}}]}
        config_system: {},
        buyerSignForm: {},//买家注册数据缓存
    },
    mutations: {
        set(state, data) {
            state[data.key] = data.value
        },
    },

    getters: {
        stepData: state => {
            return state.stepData * 100 + '%'
        }
    },
    actions: {},
    modules: {}
})
